import React, { Fragment, useState, useEffect } from "react";
import LatestPodcastCard from "../components/LatestPodcastCard";
import PodcastHeader from "../components/PodcastHeader";
import Navbar from "./../components/Navbar";
import { episodeData } from "../components/episodeData";
import Episodes from "./Episodes";
import StoreCTA from "./../components/StoreCTA";

const Podcasts = () => {
  const [latestEpisode, setLatestEpisode] = useState([]);

  useEffect(() => {
    setLatestEpisode(episodeData[0]);
  }, []);

  const {
    title,
    applePodcastUrl,
    googlePodcastUrl,
    spotifyPodcastUrl,
    anchorPodcastUrl,
    imageUrl,
    description,
  } = latestEpisode;

  return (
    <Fragment>
      <div className="bg-cream px-4 py-12 md:px-16 md:py-24">
        <Navbar />
        <PodcastHeader />
        <LatestPodcastCard
          title={title}
          applePodcastUrl={applePodcastUrl}
          googlePodcastUrl={googlePodcastUrl}
          spotifyPodcastUrl={spotifyPodcastUrl}
          anchorPodcastUrl={anchorPodcastUrl}
          imageUrl={imageUrl}
          description={description}
        />
      </div>
      <div className="px-4 py-12">
        <Episodes />
      </div>
      <StoreCTA />
    </Fragment>
  );
};

export default Podcasts;
